export default "__VITE_ASSET__DdWfbO3C__"